export default __webpack_public_path__ + "aa798d134ebe38fdbf0baba2e6fc5f7b.png";